import { useEventCallback } from '@repo/shared/hooks';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { isLoggedIn, useLogin } from '@/lib/login';

export const Route = createFileRoute('/_auth')({
	beforeLoad: async ({ context }) => {
		// TODO: directly accesing auth token is not recommended.
		// once we have some interactive api or a way to expose it via context, we should use that instead.
		if (!isLoggedIn(context)) {
			throw new Error('NOT_LOGGED_IN');
		}
	},
	errorComponent: ({ error }) => {
		const isLoggedIn = error.message !== 'NOT_LOGGED_IN';
		const { triggerLogin } = useLogin({ hideSkip: true });
		const router = useRouter();

		const login = useEventCallback(() => {
			triggerLogin(() => {
				router.invalidate();
			});
		});

		useEffect(() => {
			if (!isLoggedIn) {
				login();
			}
		}, [login, isLoggedIn]);

		if (!isLoggedIn) {
			return null;
		}

		throw error;
	},
	ssr: false,
});
